import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af, bareButtonCss, hoverQuery } from '../theme';

const styles = {
  /**
   * The primary's geometry exactly — same 56px, same radius, same cap height — in paper with an
   * inset hairline instead of ink.
   *
   * Matching the size is the point: on a confirmation the two are alternatives, not a button and
   * its footnote, and shrinking this one would say the candidate is meant to take the other.
   */
  root: css`
    ${bareButtonCss};
    width: 100%;
    min-height: 56px;
    border-radius: ${af.rBtn};
    background: ${af.paper};
    box-shadow: inset 0 0 0 1px ${af.line};
    margin-top: ${af.sp3};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${af.sp2};
    transition:
      background 0.12s ease,
      box-shadow 0.12s ease;

    svg {
      width: 16px;
      height: 16px;
      flex: 0 0 16px;
    }

    /* Pointer devices only: on touch the state would stay after the tap. */
    ${hoverQuery} {
      &:not(:disabled):hover {
        background: ${af.fill};
        box-shadow: inset 0 0 0 1px ${af.muted};
      }
    }

    &:disabled {
      color: ${af.muted};
      cursor: not-allowed;
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
